var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChangePassward = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 6,
    fill: "#E4E6EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 29.4H44.5C44.8978 29.4 45.2794 29.5633 45.5607 29.854C45.842 30.1447 46 30.5389 46 30.95V46.45C46 46.8611 45.842 47.2553 45.5607 47.546C45.2794 47.8367 44.8978 48 44.5 48H20.5C20.1022 48 19.7206 47.8367 19.4393 47.546C19.158 47.2553 19 46.8611 19 46.45V30.95C19 30.5389 19.158 30.1447 19.4393 29.854C19.7206 29.5633 20.1022 29.4 20.5 29.4H22V27.85C22 26.4252 22.2716 25.0143 22.7993 23.6979C23.3269 22.3815 24.1004 21.1854 25.0754 20.1779C26.0504 19.1704 27.2079 18.3712 28.4818 17.8259C29.7557 17.2806 31.1211 17 32.5 17C33.8789 17 35.2443 17.2806 36.5182 17.8259C37.7921 18.3712 38.9496 19.1704 39.9246 20.1779C40.8996 21.1854 41.6731 22.3815 42.2007 23.6979C42.7284 25.0143 43 26.4252 43 27.85V29.4ZM40 29.4V27.85C40 25.7946 39.2098 23.8233 37.8033 22.3699C36.3968 20.9165 34.4891 20.1 32.5 20.1C30.5109 20.1 28.6032 20.9165 27.1967 22.3699C25.7902 23.8233 25 25.7946 25 27.85V29.4H40ZM31 35.6V41.8H34V35.6H31Z",
    fill: "#242526"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChangePassward);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/change-passward.1e381d4d1231a8ac28b6d1adcfd82fd5.svg";